<div *ngFor="let indicadores of indicadoresList; let i = index" class="m-b">
  <div [attr.aria-expanded]="indicadores?.isCollapsed">
    <div class="well well-lg card card-block card-header" [ngClass]="{'active': indicadores?.isCollapsed}">
      <div class="col-10 name_indicador" (click)="indicadores.isCollapsed = !indicadores?.isCollapsed">
        {{indicadores?.title}}
      </div>
    </div>
  </div>

  <div class="system-table table-container" [collapse]="!indicadores?.isCollapsed" [isAnimated]="true">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th class="text-center">Código</th>
            <th>Indicador</th>
            <th class="text-center">Polar.</th>
            <th class="text-center">Medida</th>
            <th class="text-center">Meta</th>
            <th class="text-center">Realizado</th>
            <th class="text-center">Apuração</th>
            <th class="text-center">Status</th>
            <th class="text-center">Projeção</th>
            <th class="text-center">Atualização</th>
            <th class="text-center">PC</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of indicadores.indicadores; let i = index">
            <tr>
              <td class="text-center title">{{ item?.code }}</td>
              <td>
                {{item?.title}}
                <div class="responsavel">
                  <img *ngIf="item?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="item?.resp_nome" placement="bottom" (click)="viewResonsavel(item)">
                  <div *ngIf="item?.level_mon_id" class="tag">Estratégico</div>
                </div>
              </td>
              <td>
                <div class="text-center" *ngIf="item?.polarity; else polarity">
                  <i class="fa fa-sharp fa-solid fa-arrow-up"></i>
                </div>
                <ng-template #polarity>
                  <div class="text-center">
                    <i class="fa fa-sharp fa-solid fa-arrow-down"></i>
                  </div>
                </ng-template>
              </td>
              <td>
                {{ item?.unit_id }}
                <div *ngIf="item?.accum || item?.accum_table; else accum">
                  <small>Acumulado</small>
                  <div *ngIf="item?.accum_table">
                    <small>(visão composta)</small>
                  </div>
                </div>
                <ng-template #accum>
                  <div>
                    <small>Não Acumulado</small>
                  </div>
                </ng-template>
              </td>
              <td class="text-center">{{ item?.meta }}</td>
              <td class="text-center">{{ item?.current_done }}</td>
              <td class="text-center">{{ item?.current_month }}</td>
              <td class="status">
                <div [innerHTML]="item?.status"></div>
              </td>
              <td class="text-center status">
                <div class="stat_id" *ngIf="item?.stat_id; else stat">
                  <span *ngIf="item?.stat_id == 1" class="icon-system-Seta_cima"></span>
                  <span *ngIf="item?.stat_id == 2" class="icon-system-Dificuldades"></span>
                  <span *ngIf="item?.stat_id == 3" class="icon-system-Seta_baixo"></span>
                </div>
                <ng-template #stat>
                  <div>
                    <span class="ind-status ind-status-0"></span>
                  </div>
                </ng-template>
              </td>
              <td class="text-center">{{ item?.atualizacao }}</td>
              <td class="destaque-red">{{ item?.total_pc }}</td>
              <td>
                <div class="btn-icon">
                  <span class="icon-table" (click)="viewIndicador(indicadores?.pf_id, item?.id)">
                    <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                  </span>
                  <span class="icon-table" (click)="viewInfo(item)" *ngIf="item?.viewInfo">
                    <img src="assets/images/svgs/arrows-{{item?.viewInfoActive ? 'close' : 'open'}}.svg" alt="Situação" [tooltip]="item?.viewInfoActive ? 'Ocultar situação' : 'Mostrar situação'" placement="bottom">
                  </span>
                </div>
              </td>
            </tr>
            
            <tr *ngIf="item?.viewInfoActive && item?.analysis_description && item?.acSituationRange">
              <td class="title"><strong>Análise:</strong></td>
              <td colspan="12">{{ item?.analysis_description }}</td>
            </tr>

            <ng-container *ngIf="item?.viewInfoActive && item?.analysis && !item?.acSituationRange">
              <tr *ngFor="let analysis of item?.analysis">
                <td class="title"><strong>Análise em {{ analysis?.ctr_dth_atu }} por {{ analysis?.user }}:</strong></td>
                <td colspan="12">{{ analysis?.description }}</td>
              </tr>
            </ng-container>

            <tr *ngIf="item?.viewInfoActive && item?.goal">
              <td class="title" colspan="13">
                <strong>Início:</strong> {{ item?.year_start }}
                <strong style="padding-left: 5px;">Término:</strong> {{ item?.year_end }}
                <strong style="padding-left: 5px;">Valor Total:</strong> {{ item?.decimal_goal }}
              </td>
            </tr>

            <tr *ngIf="item?.viewInfoActive && item?.chartData">
              <td colspan="13">
                <canvas baseChart class="chart" [data]="item?.chartData" [options]="item?.chartOptions" [type]="item?.chartType"></canvas>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="text-center" *ngIf="indicadoresList?.length == 0">
  <h3>Nenhum Indicador Vinculado ao {{entity?.title}}</h3>
</div>

<div class="hr-line-dashed"></div>
<div class="form-group row d-flex justify-content-end">
  <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
    <button class="btn btn-white" type="button" (click)="voltar()">Voltar</button>
  </div>
</div>


<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>